// Specific Heat Capacity units with conversion factors to joule per kilogram kelvin (J/(kg·K))
export const specificHeatUnits = [
  { id: 'joule-per-kilogram-kelvin', name: 'Joule/Kilogram·K', symbol: 'J/(kg·K)', plural: 'Joules/Kilogram·K', factor: 1 },
  { id: 'joule-per-kilogram-celsius', name: 'Joule/Kilogram·°C', symbol: 'J/(kg·°C)', plural: 'Joules/Kilogram·°C', factor: 1 },
  { id: 'kilojoule-per-kilogram-kelvin', name: 'Kilojoule/Kilogram·K', symbol: 'kJ/(kg·K)', plural: 'Kilojoules/Kilogram·K', factor: 1000 },
  { id: 'calorie-per-gram-celsius', name: 'Calorie/Gram·°C', symbol: 'cal/(g·°C)', plural: 'Calories/Gram·°C', factor: 4186.8 },
  { id: 'kilocalorie-per-kilogram-celsius', name: 'Kilocalorie/Kilogram·°C', symbol: 'kcal/(kg·°C)', plural: 'Kilocalories/Kilogram·°C', factor: 4186.8 },
  { id: 'btu-per-pound-fahrenheit', name: 'BTU/Pound·°F', symbol: 'BTU/(lb·°F)', plural: 'BTU/Pound·°F', factor: 4186.8 },
  { id: 'btu-per-pound-rankine', name: 'BTU/Pound·R', symbol: 'BTU/(lb·R)', plural: 'BTU/Pound·R', factor: 4186.8 },
  { id: 'joule-per-gram-celsius', name: 'Joule/Gram·°C', symbol: 'J/(g·°C)', plural: 'Joules/Gram·°C', factor: 1000 },
];

export const popularSpecificHeatConversions = [
  { from: 'joule-per-kilogram-kelvin', to: 'btu-per-pound-fahrenheit' },
  { from: 'btu-per-pound-fahrenheit', to: 'joule-per-kilogram-kelvin' },
  { from: 'joule-per-kilogram-kelvin', to: 'calorie-per-gram-celsius' },
  { from: 'calorie-per-gram-celsius', to: 'joule-per-kilogram-kelvin' },
  { from: 'kilojoule-per-kilogram-kelvin', to: 'joule-per-kilogram-kelvin' },
  { from: 'joule-per-gram-celsius', to: 'joule-per-kilogram-kelvin' },
];

export const getUnitById = (id) => specificHeatUnits.find(unit => unit.id === id);

export const convertSpecificHeat = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.factor;
  return baseValue / toUnit.factor;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert ${fromUnit.plural.toLowerCase()} to ${toUnit.plural.toLowerCase()} and learn the conversion formula.`;
};
